import {formatNumber, getLocaleNumberFormat, NumberFormatStyle} from '@angular/common';

declare function DoraGetLocale(): string;

export class DoraNumber {
    public static formatNumber(value: number, locale: string, format: string): string {
        if (format === undefined || format === null) {
          format = '#.#';
        }
        const posNegFormat: string[] = format.split(';');

        const flNegative = value < 0;
        const formatToUse = flNegative && posNegFormat.length > 1 ? posNegFormat[1] : posNegFormat[0];


        // get integer and decimal parts
        const intDecFormat: string[] = formatToUse.split('.');

        const flThousandSeparator = intDecFormat[0].search(',') < 0 ? false : true;

        let mainFormat = '1';

        // Integer part fixed 1
        // mainFormat = this.countDigit(intDecFormat[0], /[#0]/g).toString();

        if (intDecFormat.length > 1) {
            // decimal parts
            mainFormat += '.' + this.countDigit(intDecFormat[1], /[#0]/g).toString();
            const fixedDecimal = this.countDigit(intDecFormat[1], /[0]/g);
            if (fixedDecimal > 0) {
                mainFormat += '-' + this.countDigit(intDecFormat[1], /[0]/g).toString();
            }
        } else {
          mainFormat += '.0-0';
        }

        let result = formatNumber(value, (locale === null ? DoraGetLocale() : locale)   , mainFormat);

        if (flThousandSeparator === false) {
          // remove thousand separator
          result = result.replace(this.getThousandSeparator(locale), '');
        }
        if (formatToUse.charAt(0) === '(') {
            result = '(' + result.substring(1, result.length) + ')';
        }
        return result;
    }
    private static countDigit(src: string, pattern: RegExp): number {
        const regExResult: RegExpMatchArray = src.match(pattern);
        return regExResult === null ? 0 : regExResult.length;
    }

    private static getThousandSeparator(locale: string): string {
      switch ((locale === null ? DoraGetLocale() : locale)) {
        case 'de':
        case 'fr':
        case 'it':
          return '.';
        default:
          return ',';
      }
    }
}
